module.exports = __webpack_public_path__ + "img/title.380ffda8.png";